export default "__VITE_PUBLIC_ASSET__fa62a1a0__"